"use strict";
/** @module BryxApi.ManagementApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
var cerealParse_1 = require("../../cerealParse");
/**
 * Mixin for management join request API calls.
 */
var JoinRequestMixin = /** @class */ (function () {
    function JoinRequestMixin() {
    }
    /**
     * Get active join requests for an agency w/ pagination
     * @param agencyId
     * @param status
     * @param limit
     * @param page
     * @param query
     * @param sortConfig
     * @param callback
     */
    JoinRequestMixin.prototype.getJoinRequests = function (agencyId, status, limit, page, query, sortConfig, callback) {
        var _this = this;
        var urlParams = {
            status: status.map(function (s) { return models_1.JoinRequestStatusEnum[s]; }).join('+'),
            limit: limit,
            page: page,
            sortBy: sortConfig.column,
            order: sortConfig.direction,
        };
        if (query != null) {
            urlParams.query = query;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, 'joinRequests', models_1.JoinRequest.parse); }));
        };
        this.http.get("/agencies/".concat(agencyId, "/join-requests"), urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get the count of pending join requests by agency ID
     * @param agencyId
     * @param callback
     */
    JoinRequestMixin.prototype.getPendingJoinRequestCount = function (agencyId, callback) {
        var _this = this;
        var urlParams = {
            status: models_1.JoinRequestStatusEnum[models_1.JoinRequestStatusEnum.pending],
            limit: 1,
            page: 0,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) {
                var result = models_1.PageResult.parse(o, 'joinRequests', models_1.JoinRequest.parse);
                return result.success == true ?
                    cerealParse_1.ParseUtils.parseSuccess(result.value.count) : cerealParse_1.ParseUtils.parseFailure(result.justification);
            }));
        };
        this.http.get("/agencies/".concat(agencyId, "/join-requests"), urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Approve multiple join requests
     * @param agencyId
     * @param requests
     * @param message
     * @param canRespond
     * @param canSend
     * @param responseOptionIds
     * @param callback
     */
    JoinRequestMixin.prototype.approveJoinRequests = function (agencyId, requests, message, canRespond, canSend, responseOptionIds, callback) {
        var _this = this;
        var body = {
            requests: requests.map(function (r) {
                return {
                    requestId: r.id,
                    message: message,
                    groups: [{
                            id: r.unit.id,
                            permissions: {
                                canRespond: canRespond,
                                canSend: canSend,
                            },
                            responseOptions: responseOptionIds,
                        }],
                };
            }),
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.JoinRequestResponse.parse, 'throw'));
        };
        this.http.put('/join-requests/approve', null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Deny multiple join requests
     * @param agencyId
     * @param requestIds
     * @param reason
     * @param callback
     */
    JoinRequestMixin.prototype.denyJoinRequests = function (agencyId, requestIds, reason, callback) {
        var _this = this;
        var body = {
            requests: requestIds,
            message: reason,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.JoinRequestResponse.parse, 'throw'));
        };
        this.http.put('/join-requests/deny', null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    return JoinRequestMixin;
}());
exports.default = JoinRequestMixin;
//# sourceMappingURL=JoinRequestMixin.js.map